/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { shape, string, arrayOf, func, bool } = proptypes;
import classNames from 'classnames';
import {
  TileContent,
  TileMedia,
  TileText,
  Tile
} from '@one-thd/sui-atomic-components';
import { noop } from '../../utils/utils';

const CategoryTab = ({ isSelected, category, onClick }) => {

  const textClass = (textLength) => classNames(
    'sui-pl-1 sui-w-36 sui-line-clamp-2', {
      'sui-py-2': textLength < 21
    }
  );

  return (
    <Tile
      onClick={onClick}
      value={category.name}
      aria-label={category.name}
      selected={isSelected}
    >
      <TileContent>
        <TileMedia
          component="img"
          className="sui-w-[30px] sui-h-[30px]"
          src={category.image.url}
          alt={`${category.name} product image`}
          loading="lazy"
        />
        <TileText size="small">
          <div className={textClass(category.name.length)}>
            {category.name}
          </div>
        </TileText>
      </TileContent>
    </Tile>
  );
};

CategoryTab.displayName = 'CategoryTab';

CategoryTab.propTypes = {
  isSelected: bool,
  category: shape({
    name: string.isRequired,
    itemIds: arrayOf(string.isRequired).isRequired,
    categoryId: string.isRequired,
    image: shape({
      url: string.isRequired
    }).isRequired
  }).isRequired,
  onClick: func,
};

CategoryTab.defaultProps = {
  isSelected: false,
  onClick: noop,
};

export { CategoryTab };
